(() => {
  'use strict';

  const section    = document.getElementById('wsGuaranteeSection');
  const trailLayer = document.getElementById('wsGuaranteeTrailLayer');
  if (!section || !trailLayer) return;

  // Collect source image URLs from hidden [data-trail] imgs
  const sourceImgs = Array.from(trailLayer.querySelectorAll('img[data-trail]'))
    .map(function (img) { return img.getAttribute('src'); });
  if (!sourceImgs.length) return;

  let trailIndex   = 0;
  let lastSpawn    = 0;
  const spawnInterval = 90;   // ms minimum between spawns
  const lifeMs        = 1000; // ms before removing spawned img
  let lastX = null;
  let lastY = null;

  section.addEventListener('mousemove', function (e) {
    const now  = performance.now();
    const rect = section.getBoundingClientRect();
    const x    = e.clientX - rect.left;
    const y    = e.clientY - rect.top;

    // Require minimum cursor movement (8px²) before spawning
    if (lastX !== null) {
      const dx = x - lastX;
      const dy = y - lastY;
      if (dx * dx + dy * dy < 64) return;
    }

    // Throttle spawn rate
    if (now - lastSpawn < spawnInterval) return;
    lastSpawn = now;
    lastX = x;
    lastY = y;

    // Create trail image
    const img       = document.createElement('img');
    img.src         = sourceImgs[trailIndex % sourceImgs.length];
    img.className   = 'ws-guarantee-trail-img';
    img.style.left  = x + 'px';
    img.style.top   = y + 'px';
    img.alt         = '';
    img.draggable   = false;

    // Random subtle rotation ±15°
    const rot = (Math.random() - 0.5) * 30;
    img.style.setProperty('--trail-rot', rot + 'deg');

    trailLayer.appendChild(img);
    trailIndex++;

    // Remove after animation completes
    setTimeout(function () {
      if (img.parentNode) img.parentNode.removeChild(img);
    }, lifeMs);
  });

  section.addEventListener('mouseleave', function () {
    lastX = null;
    lastY = null;
  });
})();
